export const PHONE_TYPE = {
  FIXED_LINE: 'FIXED_LINE',
  MOBILE: 'MOBILE',
  TOLL_FREE: 'TOLL_FREE',
  PREMIUM_RATE: 'PREMIUM_RATE',
  PERSONAL_NUMBER: 'PERSONAL_NUMBER',
  VOICEMAIL: 'VOICEMAIL',
  UAN: 'UAN',
  PAGER: 'PAGER',
  VOIP: 'VOIP',
  SHARED_COST: 'SHARED_COST',
};
